module.exports = __webpack_public_path__ + "static/media/S (92).f8d63a66.jpg";